<template>
    <SvgIcon width="17px" height="17px" icon="edit-icon" />
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "EditIcon",
    components: { SvgIcon }
};
</script>
